import { Component, OnInit, transition } from '@angular/core';

import { AuthService } from '../../../../services/auth.service';
import { GlobalService } from '../../../../services/global.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {
  auth;

  role = "";
  sub_role = "";
  urlNow;
  active_menu;
  sideActive;
  routerLinkUrl = '/' + this.authService.role + '/dashboard';

  versionNumberText='ver0.1';

  constructor(
    private globalService : GlobalService,
    private router: Router,
    private authService: AuthService,
    private http: Http
  ) { 
    this.sideActive = true;
    this.readRevisionNumber();//read appVersion
   }

  ngOnInit() {
    var URL = window.location.pathname;
    this.urlNow = URL.split("/")
  }
  
  /** @function setClass */
   // the above is the same as:
   /** @function
    * @name setClass
    * 
    * @param {array} value second url checking 
    * @todo parsedata for checking scond URL Active  for class link
    *  */
  setClass(value){
    this.active_menu = localStorage.getItem('active_menu');   

    if(this.urlNow[2] == value){
      if(this.active_menu != this.urlNow[2]){
       localStorage.removeItem('active_menu');
      }
    } 

    
    if(this.urlNow[2] == value || this.active_menu == value){
      return "nav-link active h5";
    }else{
      return "nav-link h5";      
    }
  }
  

    /** @function notActive */
   // the above is the same as:
   /** @function
    * @name notActive
    * 
    * @param {array} value second url checking 
    * @todo parsedata for checking scond URL Active  for class link
    *  */
   notActive(value){
    this.active_menu = localStorage.getItem('active_menu');   

    if(this.urlNow[2] == value){
      if(this.active_menu != this.urlNow[2]){
       localStorage.removeItem('active_menu');
      }
    } 

    
    if(this.urlNow[2] == value || this.active_menu == value){
      return "nav-link active h5";
    }else{
      return "nav-link h5";      
    }
  }

  logOut(){
    var role = this.authService.role;
    if(confirm("ログアウトしますか？")) {
      this.auth = this.authService.deleteAuth();
      
      if(!this.auth){
        if(role == 'student'){
          this.router.navigate(['/student/login']); // Navigate to dashboard view
          window.location.reload();
        }else{
          this.router.navigate(['/login']); // Navigate to dashboard view
          window.location.reload();
        }
      }
    }
  }
  /** @function checkAuth */
   // the above is the same as:
   /** @function
    * @name checkAuth
    * 
    * @param {array} value second url checking 
    * @todo parsedata for checking scond URL Active  for class not link
    *  */
  checkAuth(value){ 
   if(value == this.authService.role){
      return true;
   }else{
      return false;
   }
  }
  checkSubAuth(value){
    if(this.authService.sub_role && value == this.authService.sub_role){
      return true;
    }else{
      return false;
    }
   }
  
  checkAuthTemp(value){
    if(this.authService.role == ''){
      return true;
   }else{
      return false;
   }
  }

  //リビジョン番号読み込み(assets/revision.txtはcommit時に自動採番)
  readRevisionNumber(){
    var filepath='assets/revision.txt';
    var httpGetObservable=this.http.get(filepath);
    //console.log(httpGetObservable);
    httpGetObservable.subscribe(
      res => {
        this.versionNumberText = res.text().replace('-','.');
      },
      error => {
        //console.error(error.status + ":" + error.statusText);
      }
    );
  
  }

  changePasswd(){
    //今回は既存パスワード忘れに飛ばすのみ
    //パスワード変更機能をしっかり実装するならここに処理書く
    let changeTargetLoginId=this.authService.user.loginid;
    this.router.navigate(['/student/forget_password'], { queryParams: { ct: changeTargetLoginId }} );
  }

}



// WEBPACK FOOTER //
// ./src/app/component/elements/navigation/sidebar/sidebar.component.ts